import React from 'react';
import PropTypes from 'prop-types';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Field } from 'formik';

import { Typography } from '@telus-uds/components-web';
import { CONSTANT, storeCodeOutletMapping, storeCodes } from '../../utils/constant';

import ErrorIcon from '../../../assets/images/icon_error_messages.gif';

const CorpStoreForm = ({ values, labels, touched, errors,setFieldValue }) => {

    const getMappedOutletId = storeCodeValue => {
        return storeCodeOutletMapping[storeCodeValue] || null;
  };
    const {
        KEYS: { ROLES }
    } = CONSTANT;
    return (
        <>
            <div className="main-content-form-headers">
                <Typography>{labels.STORE_CODE}</Typography>
            </div>
            <div
                style={{ position: 'relative' }}
                className={`input-container ${errors.storeCode && touched.storeCode ? 'error' : ''
                    }`}
            >
                <Typeahead
                    id="single-typehead"
                    placeholder={labels.PLACEHOLDER_STORE_CODE}
                    selected={values.storeCode ? [values.storeCode] : []} // Use selected
                    onChange={(selected) => {
                        const selectedCode = selected[0] || '';
                        setFieldValue('storeCode', selectedCode);
                        const mappedOutlet = getMappedOutletId(selectedCode);
                        if (mappedOutlet) {
                            setFieldValue('outlet', mappedOutlet);
                        }
                    }}
                    options={storeCodes}
                />

                <>
                    <div className="error_messages">
                        <Typography variant={{ colour: 'error' }}>{errors.storeCode}</Typography>
                    </div>
                    <div id="username_error_icon" className="error_messages_icon">
                        <img src={ErrorIcon} alt="error_icon" />
                    </div>
                </>
            </div>

      {/* <div className="main-content-form-headers">
        <span className="select-placeholder"><Typography>{labels.XID_TID}</Typography></span>
      </div>
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors.xid && touched.xid ? 'error' : ''
        }`}
      >
        <Field
          placeholder="XID/TID"
          className="select-style"
          type="text"
          name="xid"
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px"><Typography>{errors.xid}</Typography></span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div> */}
    </>
  );
};

CorpStoreForm.propTypes = {
  values: PropTypes.objectOf(PropTypes.string).isRequired,
  labels: PropTypes.objectOf(PropTypes.string).isRequired,
  touched: PropTypes.objectOf(PropTypes.bool).isRequired,
  errors: PropTypes.objectOf(PropTypes.string).isRequired
};

export default CorpStoreForm;
